"use client";
import { memo } from "react";
import { useTranslations } from "next-intl";

export const FormTitle = memo(function FormTitle({ name, className, bt }) {
  const t = useTranslations();

  const titles = {
    sign_in: t("sign-in"),
    reset: t("reset"),
    stats: t("stats"),
    sign_up_for_new: t("signUpForNew"),
  };
  const mBt = bt ? "md:mt-15" : "";
  const defaultClass = `block xmd:mt-8  mt-4  sm:text-[22px] xsm:leading-[44px] sm:font-medium ${mBt}  text-center md:text-[32px] md:font-bold font-semibold text-[#334155] p-0 leading-none mx-auto`;
  const newClass = className
    ? `${defaultClass} ${className} ${mBt}`
    : defaultClass;

  return <span className={newClass}>{titles[name]}</span>;
});
